import type { ProductDTO } from '@horology/shared-types';
import { api } from '../../lib/api';

export interface ProductListParams {
  q?: string;
  favoritesOnly?: boolean;
  includeInactive?: boolean;
  cursor?: number;
  limit?: number;
}

export interface ProductListResponse {
  data: ProductDTO[];
  nextCursor: number | null;
}

export async function listProducts(params: ProductListParams = {}): Promise<ProductListResponse> {
  const { data } = await api.get<ProductListResponse>('/api/products', { params });
  return data;
}

export async function getProduct(id: number): Promise<ProductDTO> {
  const { data } = await api.get<ProductDTO>(`/api/products/${id}`);
  return data;
}

export async function createProduct(form: FormData): Promise<ProductDTO> {
  const { data } = await api.post<ProductDTO>('/api/products', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function updateProduct(id: number, form: FormData): Promise<ProductDTO> {
  const { data } = await api.patch<ProductDTO>(`/api/products/${id}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteProduct(id: number): Promise<void> {
  await api.delete(`/api/products/${id}`);
}

export interface ImportRowPreview {
  sku: string;
  name?: string;
  salePrice?: number;
  taxRate?: number;
  [k: string]: unknown;
}

export interface ImportResult {
  ok: boolean;
  headers?: string[];
  rows?: ImportRowPreview[];
  errors?: Array<{ line: number; message: string }>;
  summary: { inserted: number; updated: number };
}

export async function importProductsCsv(file: File, dryRun: boolean): Promise<ImportResult> {
  const fd = new FormData();
  fd.set('file', file);
  const { data } = await api.post<ImportResult>('/api/products/import', fd, {
    params: { dryRun: dryRun ? 'true' : 'false' },
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
